import get from 'lodash/get';
import kebabCase from 'lodash/kebabCase';

export default settings => kebabCase(get(settings, 'templateType', ''));
